<template>
  <div class="chargecard-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入手机号"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'chargecard-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: 'UUID',
          key: 'uuid',
          width: 400,
          fixed: 'left'
        },
        {
          title: '原手机号',
          key: 'ori_phone',
          fixed: 'left'
        },
        {
          title: '现手机号',
          key: 'now_phone',
        },
        {
          title: '注销时间',
          key: 'created_at',
        },
      ],
      formItem: {
        key: '',
      },
      tablelist: [],

    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
  },
  methods: {
    getTableList: function () {
      var self = this;
      this.$api.user.cancellog({ "page": this.pages.page, "size": this.pages.size }).then(res => {

        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;

      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.user.cancellog(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
</script>
